













































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    VideoCallNotifyMessage: () =>
      import('@/components/common/videoCallRoom/VideoCallNotifyMessage.vue'),
    CallWorkerRelativeList: () =>
      import('@/components/patient/CallWorkerRelativeList.vue'),
    CallHistory: () => import('@/components/patient/CallHistory.vue'),
    PatientVideoCall: () =>
      import('@/components/patient/videoCallRoom/PatientVideoCall.vue')
  }
})
export default class Call extends Vue {
  $store!: ExStore

  get isSpDevice() {
    return this.$store.getters['user/device'].maxWidth480px
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get callPartners() {
    return this.$store.getters['call/callPartners']
  }

  get isCalling() {
    return this.$store.getters['videoCallRoom/isCalling']
  }

  beforeDestroy() {
    this.$store.dispatch('call/updateCallPartners', [])
  }

  handleCallClick() {
    if (this.callPartners.length === 0) {
      return
    }

    if (this.isCalling) {
      return
    }

    this.$store.dispatch('videoCallRoom/call', {
      users: this.callPartners
    })
  }
}
